import { useState } from 'react';

const DESKTOP_URL = 'https://app.terum.ai';

export function ConnectOnDesktopSheet({
  open, onClose, sourceName,
}: { open: boolean; onClose: () => void; sourceName?: string }) {
  const [copied, setCopied] = useState(false);
  if (!open) return null;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(DESKTOP_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard can be blocked; fall through — the URL is shown in the body too.
      setCopied(false);
    }
  };

  return (
    <div className="sheet-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-grip" aria-hidden="true" />
        <div className="sheet-icon" aria-hidden="true">🖥️</div>
        <h2 className="sheet-title">Connect on your computer</h2>
        <p className="sheet-body">
          {sourceName ? `Connecting ${sourceName} ` : 'Connecting a source '}
          needs the browser extension and a sign-in popup - both only work on a
          computer. Open <strong>{DESKTOP_URL}</strong> on your desktop to finish.
        </p>
        <button className="v2-btn sheet-primary" onClick={copyLink}
          style={{ background: 'var(--accent)', color: '#fff', border: 'none' }}>
          {copied ? 'Link copied ✓' : 'Copy desktop link'}
        </button>
        <button className="v2-btn sheet-secondary" onClick={onClose}>Got it</button>
      </div>
    </div>
  );
}
